import script from "./MapControls.vue?vue&type=script&setup=true&lang=js"
export * from "./MapControls.vue?vue&type=script&setup=true&lang=js"

import "./MapControls.vue?vue&type=style&index=0&id=b996b97e&lang=scss&scoped=true"

import exportComponent from "/builds/sovhoz/front-lk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b996b97e"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QIcon});
